<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Billing Overview</el-breadcrumb-item>
      <el-breadcrumb-item>Subscribers Retention</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <h2 style="text-align: left;"> Overview of Subscription Retention </h2>

    <div class="container">
      <div style="margin-bottom: 20px; margin-right: 80px; " size="medium">
        <el-radio-group v-model="cycle">
          <el-radio-button label="daily"></el-radio-button>
          <el-radio-button label="weekly"></el-radio-button>
          <el-radio-button label="monthly"></el-radio-button>
        </el-radio-group>
      </div>
      Please Select a Date Range <span style="width: 30px;"> </span><date-range-picker @date-change="handleDateChange" /> <span
        style="width: 30px;"> </span>
    </div>
    <el-divider></el-divider>
    <div class="grid">
      <div class="chart" id="chart1">数据等待中...</div>
      <div class="chart" id="chart2">数据等待中...</div>
      <div class="chart" id="chart3">数据等待中...</div>
      <div class="chart" id="chart4">数据等待中...</div>

     </div>
    <el-divider></el-divider>
    <h3 style="text-align: left;">详细数据 <el-button type="primary" @click="exportCsv" style="  margin-left: 75%; ">下载
        CSV</el-button></h3>
    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="title" label="日期" width="150" sortable>
      </el-table-column>


      <el-table-column prop="newSubs" label="新增订阅"> </el-table-column>
      <el-table-column prop="totalSubs" label="累计订阅"> </el-table-column>

      <el-table-column prop="churnSubs" label="流失订阅"> </el-table-column>
      <el-table-column prop="billingSubs" label="扣款中订阅"> </el-table-column>

      <el-table-column prop="reactivation" label="重新回归订阅"> </el-table-column>

      <el-table-column prop="activeSubs" label="当前订阅数"> </el-table-column>

      <el-table-column prop="churnRate" label="流失率"   :formatter="formatChurnRate">    </el-table-column>

      <el-table-column prop="churnList" label="流失订阅清单" width="270">
  <template slot-scope="scope">
    <div class="list-container">
      <!-- 通过分隔符分割 churnList -->
      <div v-for="(sub, index) in scope.row.churnList.split(',')" :key="index">
         <!-- 检查 sub 是否以 '.' 结尾 -->
         <span v-if="sub.trim().endsWith('.')">
          {{ sub }}
        </span>
        <a v-else :href="'https://dashboard.stripe.com/subscriptions/' + sub" target="_blank">
          {{ sub }}
        </a>
      </div>
    </div>
  </template>
</el-table-column>


      <el-table-column prop="billingList" label="扣款中订阅清单"  width="270"   >
  <template slot-scope="scope">
    <div class="list-container">
      <!-- 通过分隔符分割 churnList -->
      <div v-for="(sub, index) in scope.row.billingList.split(',')" :key="index">
         <!-- 检查 sub 是否以 '.' 结尾 -->
         <span v-if="sub.trim().endsWith('.')">
          {{ sub }}
        </span>
        <a v-else :href="'https://dashboard.stripe.com/subscriptions/' + sub" target="_blank">
          {{ sub }}
        </a>
      </div>
    </div>
  </template>
</el-table-column>
    </el-table>


  </div>
</template>

<script>

import dateRangePicker from './dateRangePicker.vue';
import { exportToCsv } from '@/utils/exportToCsv';
export default {
  components: {
    dateRangePicker
  },

  data() {
    return {
      tableData: [],
      cycle: 'daily',
      dateRange: '',
    }
  },
  // 新增watch 观察参数变化,按照dateRange变化,重新getData
  watch: {
    dateRange() {
      this.getData();
    },
    cycle() {
      this.getData();
    },
  },

  // 新建methods 区域, 专门定义各个方法和参数的地方
  methods: {
    async getData() {

      this.tableData = []
//  params  cycle 和 dateRange
      let res = await this.$http.get("/da/get_subs_retention"  , {
      params: {
        dateRange: this.dateRange,
        cycle:  this.cycle,
      },
    })
      this.tableData = res.data
      this.initCharts();
    },

    handleDateChange(date) {
      this.dateRange = date;
      console.log('Selected date range:', this.dateRange);
    },

    exportCsv() {
      let fileName = "Subscription Trial Conversion Rate" + "_" + this.dateRange
      exportToCsv(this.tableData, fileName)
    },

    getRateColor(percent) {
      const value = parseFloat(percent) / 100
      if (value > 0.85) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= 0.8 && value < 0.85) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },
    formatChurnRate(row, column, cellValue) {
    if (cellValue === null || cellValue === undefined|| cellValue === 0) {
      return '';
    }
    // 确保显示为两位小数的百分比
    return `${(cellValue * 100).toFixed(2)}%`;
  },
  initCharts() {
  // 图表1 - activeSubs
  const chart1 = this.$echarts.init(document.getElementById("chart1"));
  const option1 = {
    title: { text: 'Active Subscribers' ,
    left: 'left', // 将标题靠左
    },
    tooltip: { trigger: 'axis' ,
    axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },  },
    xAxis: {
      type: 'category',
      data: this.tableData.map(item => item.title),
    },
    yAxis: { type: 'value' },
    series: [
      {
        name: 'Active Subs',
        type: 'line',
        data: this.tableData.map(item => item.activeSubs),
        barWidth: '50%',
      },
    ],
  };
  chart1.setOption(option1);

  // 图表2 - churnSubs, reactivation, NetGrowth
  const chart2 = this.$echarts.init(document.getElementById("chart2"));
const option2 = {
  title: { 
    text: 'Churn Subs, Reactivation, Net Growth',
    left: 'left', // 将标题居中
  },
  tooltip: { trigger: 'axis' ,
    axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },  },
  legend: {
    data: ['Churn Subs', 'New Subs', 'Reactivation', 'Net Growth'],
    top: '10%', // 将图例与标题分开，放置在标题下方
    left: 'center', // 居中放置图例
  },
  xAxis: {
    type: 'category',
    data: this.tableData.map(item => item.title),
  },
  yAxis: { type: 'value' },
  series: [
    {
      name: 'Churn Subs',
      type: 'bar',
      data: this.tableData.map(item => item.churnSubs),
      barWidth: '50%',
      stack: 'total', // 堆叠
    },
    {
      name: 'New Subs',
      type: 'bar',
      data: this.tableData.map(item => item.newSubs),
      barWidth: '50%',
      stack: 'total', // 堆叠
    },
    {
      name: 'Reactivation',
      type: 'bar',
      data: this.tableData.map(item => item.reactivation),
      barWidth: '50%',
      stack: 'total', // 堆叠
    },
    {
      name: 'Net Growth',
      type: 'line',
      data: this.tableData.map(item => item.netGrowth),
      smooth: false,
      lineStyle: { width: 2 },
    },
  ],
};
chart2.setOption(option2);

  // 图表3 - NewSubs
  const chart3 = this.$echarts.init(document.getElementById("chart3"));
  const option3 = {
    title: { text: 'New Subscribers' },
    tooltip: { trigger: 'axis' ,
    axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },  },

    xAxis: {
      type: 'category',
      data: this.tableData.map(item => item.title),
    },
    yAxis: { type: 'value' },
    series: [
      {
        name: 'New Subs',
        type: 'line',
        data: this.tableData.map(item => item.newSubs),
        barWidth: '50%',
      },
    ],
  };
  chart3.setOption(option3);

  // 图表4 - ChurnSubs
  const chart4 = this.$echarts.init(document.getElementById("chart4"));
const option4 = {
  title: { text: 'Churn Subscribers' },
  tooltip: { trigger: 'axis' ,
    axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },  },
      legend: {
    data: ['Churn Subs', 'Churn Rate'],
    top: '10%', // 将图例与标题分开，放置在标题下方
    left: 'center', // 居中放置图例
  },
  xAxis: {
    type: 'category',
    data: this.tableData.map(item => item.title),
  },
  yAxis: [
    {
      type: 'value', // 主y轴，显示 churnSubs
      name: 'Churn Subs',
    },
    {
      type: 'value', // 副y轴，显示 churnRate
      name: 'Churn Rate',
      axisLabel: {
        formatter: '{value}%', // 百分比显示
      },
    },
  ],
  series: [
    {
      name: 'Churn Subs',
      type: 'line',
      data: this.tableData.map(item => Math.abs(item.churnSubs)), // 转换负数为正数
      barWidth: '50%',
    },
    {
      name: 'Churn Rate',
      type: 'line',
      yAxisIndex: 1, // 使用副y轴
      data: this.tableData.map(item => (item.churnRate * 100).toFixed(2)), // 转换为百分比并保留两位小数
      lineStyle: { type: 'dashed' }, // 设置虚线
      // label: {
      //   show: true,
      //   formatter: '{c}%', // 数据标签显示百分比
      // },
    },
  ],
};

chart4.setOption(option4);
},
  },

  mounted: function () {


  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

.device-number-link a {
  color: blue;
  /* 鼠标悬停时变为蓝色 */
  text-decoration: none;
  /* 移除下划线 */
}

.device-number-link a:hover {
  color: #ffaa00;
  /* 点击时变为海思蓝色 */
}

.device-number-link a:active {
  color: inherit;
  /* 正常状态下使用继承的颜色，即没有特别的颜色 */

}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
  width: 95%;

}

.chart {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px;
  height: 380px;
}
.list-container {
  max-height: 80px; /* 大约三行的高度 */
  overflow-y: auto; /* 超出部分显示滚动条 */
  line-height: 20px; /* 行高，控制每行的高度 */
  white-space: nowrap;
}
</style>